// Keep all these in the order they should be shown
export enum ColorName {
    green = 'green',
    cyan = 'cyan',
    amber = 'amber',
    fuchsia = 'fuchsia',
    white = 'white'
}